<template>
    <main id="accessory-sheet-features" v-if="displayContent">
        <div class="wrapper">
            <template v-if="productVariants.length > 0">
                <div class="titled-container has-no-top-margin">
                    <div class="features-compare-container">
                        <div class="columns no-bottom-margin">
                            <div class="column is-narrow">
                                <h2 class="title is-2">
                                    {{ $t("features") }}
                                </h2>
                            </div>
                        </div>
                        <div class="columns-compare-container">
                            <div class="slider-controls">
                                <button
                                    class="action previous"
                                    :class="{available: canGoPrevious('features')}"
                                    :aria-label="$t('previous')"
                                    @click.prevent="slidePrev('features')"
                                ></button>
                                <button
                                    class="action next"
                                    :class="{available: canGoNext('features')}"
                                    :aria-label="$t('next')"
                                    @click.prevent="slideNext('features')"
                                ></button>
                            </div>
                            <div class="columns-compare-labels">
                                <div
                                    class="columns-compare-label"
                                    v-for="attributeToCompare in attributesToCompare"
                                    :key="attributeToCompare.code"
                                >
                                <span class="label-wrapper">
                                    {{ attributeToCompare.label }}
                                </span>
                                </div>
                            </div>
                            <div class="columns-compare-columns">
                                <hooper
                                    ref="features-slider"
                                    :itemsToShow="itemsToShow"
                                    :mouseDrag="false"
                                    :touchDrag="isPhone"
                                    :wheelControl="false"
                                    :centerMode="isPhone"
                                    @slide="slideChanged($event, 'features')"
                                >
                                    <slide
                                        v-for="productVariant in productVariants"
                                        :key="productVariant.identifier"
                                    >
                                        <div class="columns-compare-column">
                                            <div class="column-name">
                                              {{ productVariant.reference }}
                                            </div>
                                            <div
                                                class="column-value"
                                                v-for="attributeToCompare in attributesToCompare"
                                                :key="attributeToCompare.code"
                                            >
                                                {{ getCompareValue(productVariant, attributeToCompare.code) }}
                                            </div>
                                        </div>
                                    </slide>
                                </hooper>
                            </div>
                        </div>
                    </div>


                    <div class="compatibilities-compare-container" v-if="compatibleMachines.length > 0">
                        <div class="columns no-bottom-margin">
                            <div class="column is-narrow">
                                <h2 class="title is-2">
                                    {{ $t("compatible_machines") }}
                                </h2>
                            </div>
                            <div class="column is-full-tablet finishing-badge-container">
                                <span class="finishing-badge has-shadow available icon-check"></span>
                                {{ $t("available") }}
                            </div>
                        </div>

                        <div class="columns-compare-container">
                            <div class="slider-controls">
                                <button
                                    class="action previous"
                                    :class="{available: canGoPrevious('compatibilities')}"
                                    :aria-label="$t('previous')"
                                    @click.prevent="slidePrev('compatibilities')"
                                ></button>
                                <button
                                    class="action next"
                                    :class="{available: canGoNext('compatibilities')}"
                                    :aria-label="$t('next')"
                                    @click.prevent="slideNext('compatibilities')"
                                ></button>
                            </div>
                            <div class="columns-compare-labels">
                                <div
                                    class="columns-compare-label"
                                    v-for="compatibleMachine in compatibleMachines"
                                    :key="compatibleMachine.code"
                                >
                                    <span class="label-wrapper">
                                        <span class="reference-name">{{ compatibleMachine.label }}</span>
                                        <router-link :to="{ name: 'machine-sheet-summary', params: {id: (compatibleMachine.parent ? compatibleMachine.parent : compatibleMachine.code), name: compatibleMachine}}" class="link" :class="brandColor">
                                            {{ $t('see_the_machine') }}
                                        </router-link>
                                    </span>
                                </div>
                            </div>
                            <div class="columns-compare-columns">
                                <hooper
                                    ref="compatibilities-slider"
                                    :itemsToShow="itemsToShow"
                                    :mouseDrag="false"
                                    :touchDrag="isPhone"
                                    :wheelControl="false"
                                    :centerMode="isPhone"
                                    @slide="slideChanged($event, 'compatibilities')"
                                >
                                    <slide
                                        v-for="productVariant in productVariants"
                                        :key="productVariant.identifier"
                                    >
                                        <div class="columns-compare-column">
                                            <div class="column-name">
                                                {{ productVariant.reference }}
                                            </div>
                                            <div
                                                class="column-value"
                                                v-for="compatibleMachine in compatibleMachines"
                                                :key="compatibleMachine.code"
                                            >
                                                <span class="finishing-badge has-shadow available icon-check" v-if="checkAvailability(compatibleMachine, productVariant)"></span>
                                                <span class="unavailable" v-else>-</span>
                                            </div>
                                        </div>
                                    </slide>
                                </hooper>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="content-available-soon">
                    {{ $t('content_available_soon') }}
                </div>
            </template>
        </div>
    </main>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'
    import productService from '@/services/serli/product'
    import { Hooper, Slide } from 'hooper';
    import '@/../node_modules/hooper/dist/hooper.css';
    //import { convertUnit, getAttributeDetails } from "@/common/helpers"

    export default {
        name: 'AccessoryFeaturesView',
        components: {
            Hooper,
            Slide
        },
        data(){
            return {
                displayContent: false,
                productVariantsBasic: [],
                productVariants: [],
                attributesToCompare: [],
                compatibleMachines: [],
                slideIndex: {
                    features: 0,
                    compatibilities: 0
                },
            }
        },
        computed: {
            ...mapState({
                productDatas: state => state.sheet.productDatas,
                isPhone: state => state.settings.isPhone,
                unitType: state => state.settings.unitType
            }),
            ...mapGetters({
              localeKebabFormat: 'settings/localeKebabFormat'
            }),
            itemsToShow(){
                return this.isPhone ? 1.5 : 7
            }
        },
        created(){
            this.startLoading();
            this.fetchProductVariants() // On récupére la liste des variantes de l'accessoire en cours
            .then(() => this.addReferenceToVariants())
            .then(() => this.fetchAttributesToCompare()) // On va regarder la liste des attributs a comparer entre toutes les variantes
            .then(() => this.addAttributesToCompareToProductVariants()) // On met la liste des attributs de comparaison dans une nouvelle propriété des variantes
            .then(() => this.getCompatibleMachines()) // On va chercher les machines compatibles pour chaque variante
            .finally(() => {
                this.stopLoading();
                this.displayContent = true;
            });
        },
        methods: {
            async fetchProductVariants(){
              this.productVariants=this.productDatas.variants
            },
            async addReferenceToVariants(){
              var productVariants=[]
              this.productVariants.forEach((variant)=>{
                productVariants.push(this.addReference(variant))
              })
              this.productVariants=productVariants
            },
            async fetchAttributesToCompare(){
                if(this.productVariants.length > 0) {
                    const attributeGroupCodes = [
                        'weight_and_dimensions',
                        'capacities'
                    ];

                  let attributeGroups = [];
                  let attributesToCompare = [];

                  attributeGroupCodes.forEach(attributeGroupCode => {
                    var attributeGroup=this.productVariants[0].orderedTechnicalGroups.find(x => x.groupCode === attributeGroupCode)
                    if(attributeGroup) {
                      attributeGroups.push(attributeGroup)
                      attributeGroup.attributes.forEach(attribute => {
                        attributesToCompare.push(attribute)
                      })
                    }
                  })

                  this.attributesToCompare = attributesToCompare;
                }
            },
            async getCompatibleMachines(){
              await productService.accessoryMachines(this.productDatas.identifier, {
                full: false,
                locale: this.localeKebabFormat
              }).then((response) => this.compatibleMachines = response.data.data)

              this.compatibleMachines.sort(function(a,b) {
                return (a.label<=b.label) ? -1 : 1;
              })

              if(this.productVariants.length > 0){
                let productVariantsWithCompatibilities = [];
                for(const productVariant of this.productVariants){
                  Object.assign(productVariant, {
                    machinesCompatibility: []
                  })

                 await productService.accessoryMachines(productVariant.identifier, {
                    full: false,
                    locale: this.localeKebabFormat
                  }).then((response) => {
                    productVariant.machinesCompatibility = response.data.data
                    productVariantsWithCompatibilities.push(productVariant)
                  })

                }
                this.productVariants = productVariantsWithCompatibilities;
              }
            },
          async addAttributesToCompareToProductVariants(){
            if(this.productVariants.length > 0){
              let productVariantsWithValues = [];
              for(const productVariant of this.productVariants){
                Object.assign(productVariant, {
                  compareValues: []
                })
                for(const attributeToCompare of this.attributesToCompare){
                  productVariant.orderedTechnicalGroups.forEach(attribute=>{
                    attribute.attributes.forEach(attr=>{
                      if(attr.code===attributeToCompare.code) productVariant.compareValues.push(attr)
                    })
                  })
                }
                productVariantsWithValues.push(productVariant);
              }
              this.productVariants = productVariantsWithValues;
            }
          },
          async sortProductVariants() {
            var productVariants=this.productVariants
            await productVariants.sort(function(a, b) {
              if (a.reference<b.reference)
              {console.log(a.reference+'<'+b.reference);return -1;}
              else if (a.reference>b.reference)
              {console.log(a.reference+'>'+b.reference);return 1;}
              else return 0;
            })
            this.productVariants=productVariants
          },
          addReference(product){
            let referenceAttributes = [
              'bucket_references',
              'clamp_references',
              'forks_carriages_references',
              'forks_grabs_references',
              'jibs_crane_references',
              'mining_references',
              'platform_references',
              'reference_skid_steer_carriage',
              'skip_references',
              'sweepers_cleaners_references',
              'winches_references',
              'reference_euro_carriage',
              'reference_4_point_carriage',
              'reference_all_tach'
            ]

            let reference = '';
            var findRef=false;
            referenceAttributes.forEach(referenceAttribute => {
              var attribute=product.attributes.find(x=>x.code===referenceAttribute)
              if (attribute && !findRef) {
                reference = attribute.value.code

                reference = this.$_.replace(reference, /__/g, '/')
                reference = this.$_.replace(reference, /_/g, ' ')
                findRef=true

              }
            })
            product.reference=reference
            return product
          },
              getCompareValue(product, attributeCode){
                let value = null;
                let attributeDatas = product.compareValues.find(x => x.code === attributeCode);
                if(attributeDatas)
                    value = attributeDatas.value.display[this.unitType];
                if(!value)
                    value = '-';
                return value;
            },
            checkAvailability(compatibleMachine, productVariant){
                return productVariant.machinesCompatibility.find(x=>x.code===compatibleMachine.code);
            },

            slidePrev(type) {
                if(this.canGoPrevious(type))
                    this.$refs[type+'-slider'].slidePrev();
            },
            slideNext(type) {
                if(this.canGoNext(type))
                    this.$refs[type+'-slider'].slideNext();
            },
            canGoPrevious(type) {
                return this.slideIndex[type] > 0;
            },
            canGoNext(type) {
                return (this.slideIndex[type]+Math.floor(this.itemsToShow)) < this.productVariants.length;
            },
            slideChanged(payload, type) {
                this.slideIndex[type] = payload.currentSlide;
            },
        }
    }
</script>

<style lang="scss">
    #accessory-sheet-features {
        padding-top: 35px;
        padding-bottom: 40px;

        .columns-compare-container {
            position: relative;
            display: flex;
            font-size: 15px;

            .slider-controls {
                position: absolute;
                top: -60px;
                right: 0;

                @media #{$mq_phone} {
                    top: -35px;
                    right: -25px;
                }

                .action {
                    opacity: 0;
                    cursor: default;


                    &:after {
                        @include icomoon;
                        content: "\e918";
                        display: inline-block;
                        font-size: 22px;
                        color: $blackish;
                        transition: color 0.3s ease;
                    }

                    &.available {
                        opacity: 1;
                        cursor: pointer;
                    }

                    &.previous {
                        float: left;
                        margin-right: 20px;

                        &:after {
                            transform: rotate(90deg);
                        }
                    }

                    &.next {
                        float: right;
                        margin-right: 25px;

                        &:after {
                            transform: rotate(-90deg);
                        }
                    }
                }
            }

            .columns-compare-labels {
                flex: 1 0 150px;
                padding-top: 65px;

                .columns-compare-label {
                    position: relative;
                    display: flex;
                    align-items: center;
                    height: 65px;

                    &:after {
                        content: '';
                        position: absolute;
                        top: 50%;
                        left: 0;
                        z-index: 0;
                        width: calc(100vw - 60px - 5vw);
                        height: 2px;
                        background-image: url('~@/assets/img/spaced-dot.svg');
                        background-position: center center;
                        background-repeat: repeat-x;
                        background-size: 7px 2px;

                        @media #{$mq_phone} {
                            width: 60vw;
                        }
                    }

                    .label-wrapper {
                        position: relative;
                        display: inline-block;
                        background-color: $white;
                        padding-right: 5px;
                        z-index: 1;

                        .reference-name {
                            display: block;
                        }

                        .link {
                            display: inline-block;
                            margin-top: 5px;
                            text-decoration: underline;
                        }
                    }
                }
            }

            .columns-compare-columns {
                position: relative;
                flex: 1 1 calc(100% - 150px);
                width: 100%;
                display: flex;
                justify-content: space-around;
                z-index: 2;
                overflow-x: hidden;

                .hooper {
                    height: auto;

                    .hooper-slide {
                        height: auto;
                        text-align: center;

                        .columns-compare-column {
                            display: inline-block;
                            max-width: 100px;
                            overflow: hidden;
                            text-align: center;
                            margin: 0 5px;
                            padding: 0 5px;
                            border-radius: 20px;
                            background-color: $light-grey;

                            .column-name {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                height: 65px;
                                font-weight: 700;
                                text-transform: uppercase;
                                overflow: hidden;
                            }

                            .column-value {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: $medium-grey;
                                height: 65px;
                                overflow: hidden;
                            }
                        }
                    }
                }
            }
        }

        .compatibilities-compare-container {
            margin-top: 80px;

            .finishing-badge-container {
                @media #{$mq_phone} {
                    margin-top: -30px;
                }

                .finishing-badge {
                    margin-right: 8px;
                }
            }

            .unavailable {
                font-weight: 700;
                color: $blackish;
            }
        }
    }
</style>
